import Vue from "vue";
import App from "./App.vue";

const element = document.getElementById("newsletterQuickSubscription");

if (element) {
  new Vue({
    render: createElement => {
      const context = {
        props: { ...element.dataset }
      };
      return createElement(App, context);
    }
  }).$mount("#newsletterQuickSubscription");
}
